import { FormControl, FormErrorMessage, FormLabel, HStack, Input } from "@chakra-ui/react"
import { Field } from "formik"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { CmFieldTypeEnum } from "../../../constants"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import DateCustomInput from "../../DateCustomInput"

const ValidationFormFields = ({
  type,
}): React.ReactElement => {
  const { t } = useTranslation()

  const component = useMemo<React.ReactElement>(() => {
    if ([CmFieldTypeEnum.Text, CmFieldTypeEnum.Textarea].includes(type)) {
      return (
        <HStack alignItems="flex-start" width="full" justifyContent="space-between">
          <Field name="schema.minLength">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error && meta.touched}>
                    <FormLabel htmlFor='schema.minLength'>{t('minimum_characters', 'Minimum Characters')}</FormLabel>
                    <Input
                      {...field}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        form.setFieldValue(
                          "schema.minLength",
                          (
                            e.target.value !== "" ?
                            Number(e.target.value) :
                            undefined
                          )
                        )
                      }}
                      type="number"
                    />
                    <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
          <Field name="schema.maxLength">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error && meta.touched}>
                    <FormLabel htmlFor='schema.maxLength'>{t('maximum_characters', 'Maximum Characters')}</FormLabel>
                    <Input
                      {...field}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        form.setFieldValue(
                          "schema.maxLength",
                          (
                            e.target.value !== "" ?
                            Number(e.target.value) :
                            undefined
                          )
                        )
                      }}
                      type="number"
                    />
                  <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
        </HStack>
      )
    }
  
    if (type === CmFieldTypeEnum.Number) {
      return (
        <HStack alignItems="flex-start" width="full" justifyContent="space-between">
          <Field name="schema.minValue">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error && meta.touched}>
                    <FormLabel htmlFor='schema.minValue'>{t('minimum_value', 'Minimum value')}</FormLabel>
                    <Input
                      {...field}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        form.setFieldValue(
                          "schema.minValue",
                          (
                            e.target.value !== "" ?
                            Number(e.target.value) :
                            undefined
                          )
                        )
                      }}
                      type="number"
                    />
                  <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
          <Field name="schema.maxValue">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error && meta.touched}>
                    <FormLabel htmlFor='schema.maxValue'>{t('maximum_value', 'Maximum value')}</FormLabel>
                    <Input
                      {...field}
                      value={field.value ?? ""}
                      onChange={(e) => {
                        form.setFieldValue(
                          "schema.maxValue",
                          (
                            e.target.value !== "" ?
                            Number(e.target.value) :
                            undefined
                          )
                        )
                      }}
                      type="number"
                    />
                  <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
        </HStack>
      )
    }
  
    if (type === CmFieldTypeEnum.Date) {
      return (
        <HStack alignItems="flex-start" width="full" justifyContent="space-between">
          <Field name="schema.minValue">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error}>
                    <FormLabel htmlFor='schema.minValue'>{t('minimum', 'Minimum value')}</FormLabel>
                    <DatePicker
                      selected={field.value ? new Date(field.value) : undefined}
                      isClearable
                      customInput={React.createElement(React.forwardRef(DateCustomInput))}
                      onChange={(newDate: Date) => {
                        form.handleChange({
                          target: {
                            name: "schema.minValue",
                            value: newDate?.toISOString()
                          }
                        })
                      }}
                    />
                    <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
          <Field name="schema.maxValue">
            {
              ({ field, meta, form }) => (
                <FormControl isInvalid={meta.error}>
                    <FormLabel htmlFor='schema.maxValue'>{t('maximum_value', 'Maximum value')}</FormLabel>
                    <DatePicker
                      selected={field.value ? new Date(field.value) : undefined}
                      isClearable
                      customInput={React.createElement(React.forwardRef(DateCustomInput))}
                      onChange={(newDate: Date) => {
                        form.handleChange({
                          target: {
                            name: "schema.maxValue",
                            value: newDate?.toISOString()
                          }
                        })
                      }}
                    />
                    <FormErrorMessage>{meta.error}</FormErrorMessage>
                </FormControl>
              )
            }
          </Field>
        </HStack>
      )
    }
  
    return <></>
  }, [type])

  return component
}

export default ValidationFormFields
